<template>
  <div class="container-rating">
    <p class="rating">{{rating ? Number(rating).toFixed(1) : '0.0'}}</p>
    <star-rating
        :rating="rating ? Number(rating) : 0"
        :star-size="20"
        :show-rating="false"
        :rounded-corners="true"
        read-only
    />
    <p class="small">({{reviews}} ulasan)</p>
  </div>
</template>

<script>
import StarRating from 'vue-star-rating'
export default {
  components: {
    StarRating,
  },
  props: ['rating', 'reviews'],
}
</script>

<style lang="scss">
.container-rating {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-top: 10px;
    .rating {
        font-weight: 800;
        color: #CA9A00;
    }
    .small {
        font-size: 12px;
        margin-left: 6px !important;
        opacity: .7;
    }
}
</style>
